import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faInstagram,
  faYoutube,
  faFacebookF,
} from "@fortawesome/free-brands-svg-icons";

export const Contact = (props) => {
  const facebook = <FontAwesomeIcon icon={faFacebookF} size="lg" />;
  const instagram = <FontAwesomeIcon icon={faInstagram} size="lg" />;
  const youtube = <FontAwesomeIcon icon={faYoutube} size="lg" />;
  return (
    <div className="contact-view">
      <h1>Contact Us</h1>

      <div className="content_element contact_content_element">
        <p>
          <b>Email:</b>
        </p>
        <p>
          <a href="mailto:info@1882foundation.org">info@1882foundation.org</a>
        </p>
        <br />
        <p>
          <b>Address:</b>
        </p>
        <p>508 I Street NW (ground level)</p>
        <p>Washington, DC 20001</p>
        <br />
        <p>
          <b>Social Media:</b>
        </p>
        <div className="social-media">
          <div className="insta-icon">
            <a
              href="https://www.instagram.com/1882foundation/?hl=en"
              target="_blank" // click to open in new page
              rel="noopener noreferrer" // click to open in new page
            >
              {instagram}
            </a>
          </div>
          <div className="fb-icon">
            <a
              href="https://www.facebook.com/1882ProjectFoundation"
              target="_blank" // click to open in new page
              rel="noopener noreferrer" // click to open in new page
            >
              {facebook}
            </a>
          </div>
          <div className="yt-icon">
            <a
              href="https://www.youtube.com/channel/UC00NyHsuZW5OpklnE-mLwRw"
              target="_blank"
              rel="noopener noreferrer"
            >
              {youtube}
            </a>
          </div>
        </div>

        {/* a href="error.html" */}
      </div>
    </div>
  );
};
